import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const SUFFIX_SCHEMA_FIELD_NAME = "suffix";

export const getSuffixFormFieldSchema = () => yup.string().label(i18n("SuffixFormField__LABEL"));
